import { Fragment } from 'react'

/* blocks */
import DesktopHeader from './DesktopHeader'
import MobileHeader from './MobileHeader'
import { CategoriesDropdownProps } from './Header.utils'

interface Props {
  showNavLinks: boolean
  primaryCta?: { title: string; url: string }
  secondaryCta?: { title: string; url: string }
  tertiaryCta?: { title: string; url: string }
  mode: 'dark' | 'light'
  categoriesData: CategoriesDropdownProps
}

function Header({
  showNavLinks,
  primaryCta = { title: 'Book A Demo', url: '/contact-us/' },
  secondaryCta = { title: 'Log in', url: '/login/' },
  categoriesData,
  mode
}: Props) {
  return (
    <Fragment>
      <MobileHeader
        className="lg:hidden"
        categoriesData={categoriesData}
        primaryCta={primaryCta}
        secondaryCta={secondaryCta}
        mode={mode}
      />
      <DesktopHeader
        className="hidden lg:block"
        showNavLinks={showNavLinks}
        primaryCta={primaryCta}
        secondaryCta={secondaryCta}
        categoriesData={categoriesData}
        mode={mode}
      />
    </Fragment>
  )
}

export default Header
